/**
 * Grid layout configuration constants
 */
export const GRID_CONFIG = {
	/** Default number of columns in the grid */
	COLUMNS: 12,
	/** Minimum column span for a block */
	MIN_COL_SPAN: 1,
	/** Hysteresis margin in pixels for switching rows during drag */
	ROW_HYSTERESIS_PX: 12,
	/** Hysteresis margin in pixels for entering/leaving grid bounds */
	BOUNDS_HYSTERESIS_PX: 20,
	/** Delay in ms before activating between-row hover */
	BETWEEN_ROW_ENTER_DELAY_MS: 50,
} as const;
